module.exports = __webpack_public_path__ + "static/media/logo_isms.99a3058c.png";